module.exports = __webpack_public_path__ + "img/clouds-index.f4493654.png";